var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetails({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 10,
    viewBox: "0 0 2 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.171631,
    width: 1.99972,
    height: 1.91279,
    rx: 0.956396,
    fill: "#718DA7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 3.99707,
    width: 1.99972,
    height: 1.91279,
    rx: 0.956396,
    fill: "#718DA7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 7.82275,
    width: 1.99972,
    height: 1.91279,
    rx: 0.956396,
    fill: "#718DA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.38cecc8f9a27c79ef304df8fbfd46d46.svg";
export { ForwardRef as ReactComponent };